import React from 'react'

import {
  Tooltip,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, node, oneOf,
} from 'prop-types'

const VALID_TITLE_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span']

function AreaHeader({
  title,
  tooltipContent = null,
  tooltipId,
  actions = null,
  className = '',
  titleTag = 'h2',
}) {
  const TitleTag = VALID_TITLE_TAGS.includes(titleTag) ? titleTag : 'h2'

  return (
    <div className={classnames('area-header', className)}>
      <div className="area-header__title">
        {tooltipContent && tooltipId ? (
          <Tooltip
            id={tooltipId}
            content={tooltipContent}
          >
            <TitleTag className="area-header__title-text">{title}</TitleTag>
          </Tooltip>
        ) : (
          <TitleTag className="area-header__title-text">{title}</TitleTag>
        )}
      </div>
      <div className="area-header__actions">
        {actions}
      </div>
    </div>
  )
}

AreaHeader.propTypes = {
  title: string.isRequired,
  tooltipContent: node,
  tooltipId: string,
  actions: node,
  className: string,
  titleTag: oneOf(VALID_TITLE_TAGS),
}

export default AreaHeader
